// Assets/eg-accordion.js
(function() {
    function initAccordions() {
        const containers = document.querySelectorAll('[data-eg-accordion-container]');

        containers.forEach(container => {
            if (container.dataset.accordionInitialized) return;
            container.dataset.accordionInitialized = "true";

            const triggers = container.querySelectorAll('[data-eg-accordion-trigger]');
            const panels = container.querySelectorAll('[data-eg-accordion-panel]');
            const closeOthers = container.getAttribute('data-eg-accordion-close-others') === 'true';

            panels.forEach(panel => {
                if (panel.classList.contains('is-initial-open')) {
                    // `overflow: hidden` is used as a CSS signal that this panel
                    // is currently displayed in accordion mode (typically mobile).
                    // On desktop the same panel may be displayed as tabs/list/content,
                    // in which case overflow should not be hidden and max-height
                    // must not be controlled by the accordion script.
                    const isAccordionMode = window.getComputedStyle(panel).overflow === 'hidden';
                    if (isAccordionMode) {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                    }
                }
            });

            triggers.forEach(trigger => {
                trigger.addEventListener('click', function(e) {
                    e.preventDefault();

                    const id = this.getAttribute('data-eg-accordion-trigger');
                    const panel = container.querySelector(`[data-eg-accordion-panel="${id}"]`);
                    if (!panel) return;

                    panels.forEach(p => p.classList.remove('is-initial-open'));

                    const isActive = this.classList.contains('is-active');
                    const isAccordionMode = window.getComputedStyle(panel).overflow === 'hidden';

                    if (isActive) {
                        if (isAccordionMode) {
                            this.classList.remove('is-active');
                            panel.style.maxHeight = null;
                            panel.classList.remove('is-open');

                            triggers.forEach(t => {
                                if (t.getAttribute('data-eg-accordion-trigger') === id) {
                                    t.classList.remove('is-active');
                                }
                            });
                        }
                        return;
                    }

                    if (closeOthers) {
                        triggers.forEach(t => t.classList.remove('is-active'));
                        panels.forEach(p => {
                            p.style.maxHeight = null;
                            p.classList.remove('is-open');
                        });
                    }

                    triggers.forEach(t => {
                        if (t.getAttribute('data-eg-accordion-trigger') === id) t.classList.add('is-active');
                    });
                    panel.classList.add('is-open');

                    if (isAccordionMode) {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                    } else {
                        panel.style.maxHeight = null;
                    }
                });
            });

            window.addEventListener('resize', () => {
                const openPanels = container.querySelectorAll('[data-eg-accordion-panel].is-open');
                openPanels.forEach(p => {
                    if (window.getComputedStyle(p).overflow === 'hidden') {
                        p.style.maxHeight = p.scrollHeight + "px";
                    } else {
                        p.style.maxHeight = null;
                    }
                });
            });
        });
    }

    document.addEventListener('DOMContentLoaded', initAccordions);
    document.addEventListener('shopify:section:load', initAccordions);
})();
